import React, { ReactElement, ReactNode } from 'react'
import classNames from 'classnames'
import './DrawerItem.less'

/**
 * @deprecated
 * import DrawerItem from components index
 */
const DrawerItem = ({
  label,
  hint,
  children,
  className,
  bottom,
  fullWidth = false,
  dataTest = 'DrawerItem',
  ...restProps
}: React.HTMLAttributes<HTMLDivElement> & {
  label?: string | ReactElement
  hint?: string | ReactNode
  bottom?: any
  children: any
  className?: string
  fullWidth?: boolean
  dataTest?: string
}) => {
  const cssClasses = classNames('DrawerItem', className, {
    'full-width': fullWidth
  })
  return (
    <div className={cssClasses} {...restProps} data-test={dataTest}>
      <div className="DrawerItem__row">
        {label && <div className="DrawerItem__label">{label}</div>}
        <div className="DrawerItem__control">{children}</div>
      </div>
      {hint && <div className="DrawerItem__hint">{hint}</div>}
      {bottom && <div className="DrawerItem__bottom">{bottom}</div>}
    </div>
  )
}

export default DrawerItem
